<template>
  <div>
    <div id="Chart6" style="width: 100%; height: 320px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts6() {
      var myChart6 = this.$echarts.init(document.getElementById("Chart6"));
      //配置图表
      var option6 = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["A股融券卖出持股比例", "沪深全A收盘点位"],
        //   left: 0,
        //   top: 10,
        //   itemGap: 25,
        //   formatter: function (value) {
        //     if (value == "A股融券卖出持股比例") {
        //       return value + " {a|" + "2.21%" + "}";
        //     } else if (value == "沪深全A收盘点位") {
        //       return value + " {a|" + "5727.72" + "}";
        //     }
        //   },
        //   textStyle: {
        //     rich: {
        //       a: {
        //         color: "red",
        //       },
        //     },
        //   },
        //   selectedMode: false,
        // },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2022-01-02",
            "2022-01-03",
            "2022-01-04",
            "2022-01-05",
            "2022-01-06",
            "2022-01-07",
            "2022-01-08",
          ],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value) {
              if (value == "2022-01-02") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 130,
                align: "right",
              },
              b: {
                width: 130,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function () {
                  return "#fcad2a";
                },
              },
              formatter: function (value) {
                return value + "%";
              },
            },
            position: "left",
          },
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function () {
                  return "#539cff";
                },
              },
            },
            position: "right",
          },
        ],
        series: [
          {
            name: "A股融券卖出持股比例",
            type: "line",
            // stack: "Total",
            smooth: true,
            symbol: "none",
            color: "#fcad2a",
            data: [3, 2.7, 2.9, 2.8, 2.6, 3.1, 0],
            // areaStyle: {
            //   color: {
            //     type: "linear",
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [
            //       {
            //         offset: 0,
            //         color: "#fcad2a", // 0% 处的颜色
            //       },
            //       {
            //         offset: 1,
            //         color: "#fff", // 100% 处的颜色
            //       },
            //     ],
            //     global: false, // 缺省为 false
            //   },
            // },
          },
          {
            name: "沪深全A收盘点位",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#539cff",
            data: [2233, 2567, 5963, 1256, 5692, 6321, 0],
            yAxisIndex: 1,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart6.setOption(option6);
    },
  },
  mounted() {
    this.myEcharts6();
  },
};
</script>

<style scoped>
</style>